var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJasmine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8a4182;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "cls-1",
    d: "m46.17,41.49h7.67l1.9-2.62v-20.54h-11.48v20.54l1.9,2.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "cls-1",
    d: "m41.22,50.65l2.37-7.29-1.91-2.62-19.54-6.35-3.55,10.92,19.54,6.35,3.08-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-1",
    d: "m48.41,58.19l-6.2-4.51-3.08,1-12.07,16.62,9.28,6.74,12.08-16.62v-3.24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "cls-1",
    d: "m57.79,53.68l-6.2,4.51v3.24s12.08,16.62,12.08,16.62l9.29-6.74-12.08-16.62-3.08-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "cls-1",
    d: "m56.41,43.36l2.37,7.29,3.08,1,19.54-6.35-3.55-10.92-19.54,6.35-1.91,2.62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "cls-1",
    d: "m50,.5C22.71.5.5,22.7.5,49.99s22.21,49.51,49.5,49.51,49.5-22.21,49.5-49.51S77.3.5,50,.5h0Zm0,10.02c21.8,0,39.47,17.67,39.47,39.47s-17.68,39.49-39.47,39.49S10.52,71.8,10.52,49.99,28.2,10.52,50,10.52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "cls-1",
    d: "m79.98,60.99l-14.85-4.83.98-3.03,14.85,4.83-.98,3.03"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "cls-1",
    d: "m61.04,37.15l-2.57-1.87,9.18-12.63,2.57,1.87-9.18,12.63"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path52",
    className: "cls-1",
    d: "m39.12,37.03l-9.18-12.63,2.57-1.87,9.18,12.63-2.57,1.87"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "path54",
    className: "cls-1",
    d: "m19.96,60.8l-.98-3.02,14.85-4.82.98,3.02-14.85,4.82"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "path56",
    className: "cls-1",
    d: "m48.31,81.55h3.18v-15.62h-3.18v15.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasmine);
export default __webpack_public_path__ + "static/media/jasmine.9ba958a20a924cded1178d6ee69a67bc.svg";
export { ForwardRef as ReactComponent };